// @ actions
const { validateAndExecute } = require('actions/signaturePattern');

const {
    CONFIRM_SEND_EXTRACTS_VIA_MAIL_REQUEST,
    CONFIRM_SEND_EXTRACTS_VIA_MAIL_SUCCESS,
    CONFIRM_SEND_EXTRACTS_VIA_MAIL_FAILURE,

    SEND_EXTRACTS_VIA_MAIL_RESET,
    SEND_EXTRACTS_VIA_MAIL_SET_VISIBLE_STEP,
    SEND_EXTRACTS_VIA_MAIL_VALIDATE,
    SEND_EXTRACTS_VIA_MAIL_SHOW_CANCEL_MODAL,
} = require('constants/contactCenter/actionTypes');

const { APIPost } = require('utilities/APIRequestHelper');

const confirmSendExtractsViaMailInProgress = () => ({
    type: CONFIRM_SEND_EXTRACTS_VIA_MAIL_REQUEST
});

const confirmSendExtractsViaMailSuccess = payload => ({
    type: CONFIRM_SEND_EXTRACTS_VIA_MAIL_SUCCESS,
    payload
});

const confirmSendExtractsViaMailFailure = error => ({
    type: CONFIRM_SEND_EXTRACTS_VIA_MAIL_FAILURE,
    payload: {
        error
    }
});

const reset = () => ({
    type: SEND_EXTRACTS_VIA_MAIL_RESET
});

const setVisibleStep = step => ({
    type: SEND_EXTRACTS_VIA_MAIL_SET_VISIBLE_STEP,
    payload: {
        step
    }
});

const showCancelModal = (show) => ({
    type: SEND_EXTRACTS_VIA_MAIL_SHOW_CANCEL_MODAL,
    payload: {
        show
    }
});

const validateStep = step => ({
    type: SEND_EXTRACTS_VIA_MAIL_VALIDATE,
    payload: {
        step
    }
});

const confirmSendExtractsViaMailRequest = ( requestData ) => (dispatch, getState) => {
    const { sendExtractsViaMail: immSendExtractsViaMail } = getState();

    const params = {
        query: requestData
    };

    if (!immSendExtractsViaMail.get('isFetching')) {

        dispatch(confirmSendExtractsViaMailInProgress());

        APIPost({dispatch, endpoint: 'sendStatements', params})
            .then((response) => {
                dispatch(confirmSendExtractsViaMailSuccess(response))
            })
            .catch((error)=>{
                dispatch(confirmSendExtractsViaMailFailure(error))
            })
    }
};

const confirmSendExtractsViaMail = (params) => (dispatch, getState) => {
    validateAndExecute(dispatch, getState, (dispatch) => {
        dispatch(confirmSendExtractsViaMailRequest(params));
    });
}

module.exports = {
    confirmSendExtractsViaMail,
    setVisibleStep,
    validateStep,
    showCancelModal,
    reset
};
